import axios from "axios";
import { getRequestOptions } from "../../resources/configs/requests";
import { CHECK_IN_URL } from "../../resources/configs/URL";
import { formatCheckInErrorMessage } from "../../resources/messages/ErrorMessage";
import { CheckInResponsePayload } from "./checkIn.fromApi.types";
import { CheckInRequestPayload } from "./checkIn.fromUi.types";
import { parseResponse } from "../../resources/handlers/parseResponse/parseResponse";

/**
 * CheckIn an appointment
 *
 * POST
 * Endpoint: /CheckIn
 *
 * @param {string | null} memberIdentifier  Member Identifier of the person we are making this request for
 * @param {string} appointmentId  ID of the appointment
 * @param {string | null} regInstitutionCode  Reg Institution code of this appointment (e.g. "NUP")
 *
 * @returns {CheckInResponsePayload} Response payload from the remote API
 */
const checkIn = async (
  params: CheckInRequestPayload,
): Promise<CheckInResponsePayload> => {
  try {
    const response = await axios.post<CheckInResponsePayload>(
      CHECK_IN_URL(),
      params,
      getRequestOptions(),
    );
    return parseResponse(response, CHECK_IN_URL());
  } catch (error) {
    const msg = formatCheckInErrorMessage(CHECK_IN_URL());
    console.error(msg);
    throw error;
  }
};

export { checkIn };
